<template>
  <main class="mentions-main">
    <div class="container">
      <h1 class="page-title">
        MENTIONS <span class="bold">LÉGALES</span>
      </h1>

      <div class="content">
        <p class="intro-text">
          Les offres et services disponibles sur le site internet « www.cartenoire-graindepassion.fr » sont proposés par :
        </p>

        <div class="company-info">
          <p>CARTE NOIRE SAS, au capital de 103 830 406 Euros,</p>
          <p>58, avenue Emile Zola – 92100 BOULOGNE-BILLANCOURT, FRANCE RCS NANTERRE n° 813 978 038</p>
          <p>N° TVA intracommunautaire : FR 60 813 978 038 Tel : 00 33 (0)1 81 89 80 00</p>
        </div>

        <p class="contact-text">
          Afin de nous contacter par email, nous vous invitons à vous rendre sur la page prévue à cet effet accessible via l'onglet « Nous contacter »
          en bas de page de notre site, ou à l'adresse email suivante <a href="mailto:consumerservice.F@cartenoire.com" class="email-link">consumerservice.F@cartenoire.com</a>
        </p>

        <div class="hosting-section">
          <h2 class="section-title">HÉBERGEMENT</h2>
          <p class="hosting-intro">Hébergement des données :</p>
          <p class="hosting-text">
            Les données sont hébergées dans des centres de données situés en France sur des serveurs gérés par :
          </p>
          <div class="hosting-info">
            <p><strong>MongoDB Limited</strong></p>
            <p>Building 2 Number One Ballsbridge</p>
            <p>Shelbourne Rd, Dublin 4</p>
            <p>D04 Y3X9, Irlande</p>
            <p>Téléphone : <a href="tel:+35319014654" class="phone-link">+353 1 901 4654</a></p>
            <p>Email : <a href="mailto:support@mongodb.com" class="email-link">support@mongodb.com</a></p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: "MentionsLegalesView",
};
</script>

<style scoped>
.mentions-main {
  background-color: #000;
  color: white;
  min-height: calc(100vh - 150px - 60px);
  padding: 80px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.container {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}

.page-title {
  font-family: var(--font-primary);
  font-size: 84px;
  font-weight: 400;
  line-height: 1.1;
  margin: 0 0 60px 0;
  letter-spacing: 0.02em;
}

.page-title .bold {
  font-weight: 700;
}

.content {
  max-width: 900px;
  margin: 0 auto;
}

.intro-text {
  font-family: var(--font-primary);
  font-size: 17px;
  font-weight: 400;
  line-height: 1.1;
  margin: 0 0 40px 0;
}

.company-info {
  margin-bottom: 40px;
}

.company-info p {
  font-family: var(--font-primary);
  font-size: 17px;
  font-weight: 400;
  line-height: 1.1;
  margin: 0;
}

.contact-text {
  font-family: var(--font-primary);
  font-size: 17px;
  font-weight: 400;
  line-height: 1.1;
  margin: 0;
}

.email-link,
.phone-link {
  color: white;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.email-link:hover,
.phone-link:hover {
  opacity: 0.8;
}

/* Hosting section */
.hosting-section {
  margin-top: 50px;
  padding-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}

.section-title {
  font-family: var(--font-primary);
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 30px 0;
}

.hosting-intro {
  font-family: var(--font-primary);
  font-size: 17px;
  font-weight: 700;
  margin: 0 0 10px 0;
}

.hosting-text {
  font-family: var(--font-primary);
  font-size: 17px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0 0 20px 0;
}

.hosting-info {
  margin-top: 20px;
}

.hosting-info p {
  font-family: var(--font-primary);
  font-size: 17px;
  font-weight: 400;
  line-height: 1.4;
  margin: 0;
}

.hosting-info p strong {
  font-weight: 700;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .mentions-main {
    padding: 40px 20px;
  }

  .page-title {
    text-align: left;
    margin-bottom: 30px;
    font-size: clamp(36px, 12vw, 60px);
  }

  .content {
    text-align: center;
  }

  .intro-text {
    margin-bottom: 30px;
  }

  .company-info {
    margin-bottom: 30px;
  }

  .intro-text,
  .company-info p,
  .contact-text,
  .hosting-intro,
  .hosting-text,
  .hosting-info p {
    text-align: center;
    font-size: 16px;
    line-height: 1.5;
  }

  .hosting-section {
    margin-top: 30px;
    padding-top: 30px;
  }

  .section-title {
    font-size: 20px;
    margin-bottom: 20px;
  }
}

@media (max-width: 480px) {
  .mentions-main {
    padding: 30px 15px;
  }

  .page-title {
    font-size: clamp(32px, 11vw, 48px);
  }
}
</style>
